var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2 action-button-padding",attrs:{"block":_vm.$vuetify.breakpoint.xsOnly,"depressed":"","color":"primary"},on:{"click":function($event){return _vm.archiveJob(_vm.jobId, 6)}}},[_vm._v("Archive")])
}
var staticRenderFns = []

export { render, staticRenderFns }